export const PORTAL_URL = 'portal';

export enum PortalRoutePath {
	WELCOME = 'welcome',
	EASY_INPUT = 'easy-input',
	CONFIGURATION = 'configuration',
	HELP = 'help',
	DASHBOARD = 'dashboard',
	ORGANIZATIONS = 'organizations',
	CLIENT_ACCOUNTS = 'client-accounts',
	STOCK = 'stock',
	PRODUCT = 'product',
	PACKAGE_DEALS = 'package-deals',
	CAR_LIST_BANDS = 'car-list-bands',
	CAR_MODELS = 'car-models',
	LOCATION = 'location',
	COLLABORATORS = 'collaborators',
	VEHICLE_LIST = 'vehicle-list',
	VEHICLE_LIST_ADD = 'vehicle-list/add',
	CONVERSION_LIST = 'conversion-list',
	WIZARD = 'wizard',
	QUOTATION = 'quotation',
	DAILYTASKS = 'dailytasks',
}

export const getPortalRoute = (route: PortalRoutePath): string => {
	return `/${PORTAL_URL}/${route}`;
};
